// File: GLBDropzoneModal.js

import { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import {
    Modal,
    Box,
    Typography,
    Button,
    Paper,
    Stack
} from "@mui/material";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
};

export default function GLBDropzoneModal({ open, onClose, onFileUpload }) {
 
    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0];
        if (!file || !file.name.toLowerCase().endsWith('.glb')) {
            alert("Please upload a valid .glb file.");
            return;
        }
        onFileUpload(file);
        onClose();
    }, [onFileUpload, onClose]);


    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: '.glb',
        multiple: false
    });

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                <Typography variant="h6" mb={2}>Upload .glb File</Typography>
                <Paper
                    variant="outlined"
                    sx={{ p: 2, textAlign: "center", cursor: "pointer" }}
                    {...getRootProps()}
                >
                    <input {...getInputProps()} />
                    {
                        isDragActive ? (
                            <Typography>Drop the file here ...</Typography>
                        ) : (
                            <Typography>Drag and drop a .glb file here, or click to browse</Typography>
                        )
                    }
                </Paper>
                <Stack direction="row" justifyContent="flex-end" mt={2}>
                    <Button onClick={onClose}>Cancel</Button>
                </Stack>
            </Box>
        </Modal>
    );
}
